import ApiService from 'services/ApiService';

import { OLIcon, LsPoint, } from '../ls-openlayers';

export class LayerFacilityVds {

    constructor(map) {        
        this.map = map;
        this.layerIndex = 0;
        this.layerName = "vdsLayer";        
        this.map.addVectorLayer(this.layerIndex, this.layerName);
        this.setData();
    }

    setData = function () {
        const map = this.map;
        const layerName = this.layerName;
        ApiService.get("newdashboard/gis/GetVds").then(response => {
            if (response.status === 200) {
                const data = response.data;

                let id, name, x, y, stat, olData, popupHtml;
                for(let i = 0; i < data.rows.length; i++) {                                                
                    id = data.rows[i]['vdsId'];
                    name = data.rows[i]['vdsLocation'];
                    x = data.rows[i]['x'];
                    y = data.rows[i]['y'];
                    stat = data.rows[i]['stat'];

                    olData = new OLIcon(layerName);
                    olData.set(new LsPoint(x, y));
                    olData.userData.set("id", id);
                    olData.userData.set("name", name);
                    olData.userData.set("stat", stat);
                    olData.userData.set("x", x);
                    olData.userData.set("y", y);
                    olData.userData.set("type", "vds");

                    olData.style.src = stat == 1 ? "/images/facility/vds_active.png" : "/images/facility/vds_inactive.png";
                    map.addData(olData);
                }
                map.draw();
            }
        })
    }
}

export class LayerFacilityCctv {

    constructor(map) {        
        this.map = map;
        this.layerIndex = 0;
        this.layerName = "cctvLayer";        
        this.map.addVectorLayer(this.layerIndex, this.layerName);        
        //this.map.addClusterLayer(this.layerName);        
        this.setData();
    }

    setData = function () {
        const map = this.map;
        const layerName = this.layerName;
        ApiService.get("newdashboard/gis/GetCCTV").then(response => {
            if (response.status === 200) {
                const data = response.data;

                let id, name, x, y, stat, olData, popupHtml;
                for(let i = 0; i < data.rows.length; i++) {                                                
                    id = data.rows[i]['cctvId'];
                    name = data.rows[i]['cctvLocation'];
                    x = data.rows[i]['x'];
                    y = data.rows[i]['y'];
                    stat = data.rows[i]['stat'];

                    olData = new OLIcon(layerName);
                    olData.set(new LsPoint(x, y));
                    olData.userData.set("id", id);
                    olData.userData.set("name", name);
                    olData.userData.set("stat", stat);
                    olData.userData.set("x", x);
                    olData.userData.set("y", y);
                    olData.userData.set("type", "cctv");
                    //olData.userData.set("popupHtml", ReactDOMServer.renderToString(<PopupViewCctv data={olData.userData} />));

                    olData.style.src = stat == 1 ? "/images/facility/cctv_active.png" : "/images/facility/cctv_inactive.png";
                    map.addData(olData);
                }
                map.draw();
            }
        })
    }
}

export class LayerFacilityVms {

    constructor(map) {        
        this.map = map;
        this.layerIndex = 0;
        this.layerName = "vmsLayer";        
        this.map.addVectorLayer(this.layerIndex, this.layerName);
        this.setData();
    }

    setData = function () {
        const map = this.map;
        const layerName = this.layerName;
        ApiService.get("newdashboard/gis/GetVms").then(response => {
            if (response.status === 200) {
                const data = response.data;

                let id, name, x, y, stat, olData, popupHtml;
                for(let i = 0; i < data.length; i++) {
                    
                    id = data[i]['id'];
                    name = data[i]['name'];
                    x = data[i]['x'];
                    y = data[i]['y'];
                    stat = data[i]['stat'];
                    
                    olData = new OLIcon(layerName);
                    olData.set(new LsPoint(x, y));
                    olData.userData.set("id", id);
                    olData.userData.set("name", name);
                    olData.userData.set("stat", stat);
                    olData.userData.set("x", x);
                    olData.userData.set("y", y);
                    olData.userData.set("type", "vms");

                    olData.style.src = stat == 1 ? "/images/facility/vms_active.png" : "/images/facility/vms_inactive.png";
                    map.addData(olData);   
                }
                map.draw();
            }
        })
    }
}

export class LayerFacilityDsrc {

    constructor(map) {        
        this.map = map;
        this.layerIndex = 0;
        this.layerName = "dsrcLayer";        
        this.map.addVectorLayer(this.layerIndex, this.layerName);
        this.setData();
    }

    setData = function () {
        const map = this.map;
        const layerName = this.layerName;
        ApiService.get("newdashboard/gis/GetDsrc").then(response => {
            if (response.status === 200) {
                const data = response.data;

                let id, name, x, y, stat, olData, popupHtml;
                for(let i = 0; i < data.rows.length; i++) {
                    
                    id = data.rows[i]['rseId'];
                    name = data.rows[i]['rseNM'];
                    x = data.rows[i]['x'];
                    y = data.rows[i]['y'];
                    stat = data.rows[i]['stat'];
                    
                    olData = new OLIcon(layerName);
                    olData.set(new LsPoint(x, y));
                    olData.userData.set("id", id);
                    olData.userData.set("name", name);
                    olData.userData.set("stat", stat);
                    olData.userData.set("x", x);
                    olData.userData.set("y", y);
                    olData.userData.set("type", "dsrc");

                    olData.style.src = stat == 1 ? "/images/facility/dsrc_active.png" : "/images/facility/dsrc_inactive.png";
                    map.addData(olData); 
                }
                map.draw();
            }
        })
    }
}

export class LayerFacilitySurf {

    constructor(map) {        
        this.map = map;
        this.layerIndex = 0;
        this.layerName = "surfLayer";        
        this.map.addVectorLayer(this.layerIndex, this.layerName);
        this.setData();
    }

    setData = function () {
        const map = this.map;
        const layerName = this.layerName;
        ApiService.get("newdashboard/gis/GetRoad").then(response => {
            if (response.status === 200) {
                const data = response.data;

                let id, name, x, y, stat, olData, popupHtml;
                for(let i = 0; i < data.rows.length; i++) {
                    
                    id = data.rows[i]['roadId'];
                    name = data.rows[i]['roadNm'];
                    x = data.rows[i]['x'];
                    y = data.rows[i]['y'];
                    stat = data.rows[i]['roadStat'];
                    
                    olData = new OLIcon(layerName);
                    olData.set(new LsPoint(x, y));
                    olData.userData.set("id", id);
                    olData.userData.set("name", name);
                    olData.userData.set("stat", stat);
                    olData.userData.set("x", x);
                    olData.userData.set("y", y);
                    olData.userData.set("type", "surf");

                    olData.style.src = stat == 1 ? "/images/facility/surf_active.png" : "/images/facility/surf_inactive.png";
                    map.addData(olData); 
                }
                map.draw();
            }
        })
    }
}

export class LayerFacilityCrsr {

    constructor(map) {        
        this.map = map;
        this.layerIndex = 0;
        this.layerName = "crsrLayer";        
        this.map.addVectorLayer(this.layerIndex, this.layerName);
        this.setData();
    }

    setData = function () {
        const map = this.map;
        const layerName = this.layerName;
        ApiService.get("newdashboard/gis/GetSmtLos").then(response => {
            if (response.status === 200) {
                const data = response.data;

                let id, name, x, y, stat, olData, popupHtml;
                for(let i = 0; i < data.rows.length; i++) {
                    
                    id = data.rows[i]['crsrdId'];
                    name = data.rows[i]['crsrdNm'];
                    x = data.rows[i]['x'];
                    y = data.rows[i]['y'];
                    stat = data.rows[i]['stat'];
                    
                    olData = new OLIcon(layerName);
                    olData.set(new LsPoint(x, y));
                    olData.userData.set("id", id);
                    olData.userData.set("name", name);
                    olData.userData.set("stat", stat);
                    olData.userData.set("x", x);
                    olData.userData.set("y", y);
                    olData.userData.set("type", "crsr");

                    olData.style.src = stat == 1 ? "/images/facility/crsr_active.png" : "/images/facility/crsr_inactive.png";
                    map.addData(olData); 
                }
                map.draw();
            }
        })
    }
}